import Modal from 'client/components/Modal'
import React from 'react'

import { VARIANT_DEFAULT, VARIANT_FULLSCREEN } from 'client/components/Modal/constants'
import { useDevice } from 'src/hooks/useDevice'
import { BreakpointSizes } from 'src/types/device'

import styles from './styles.module.css'
import { useIntl } from 'react-intl'

interface IRoomDetailsContainerProps {
  children: React.ReactElement
  isOpen: boolean
  handleClose: () => void
}

export const RoomDetailsModal = (props: IRoomDetailsContainerProps) => {
  const { children, isOpen, handleClose } = props
  const intl = useIntl()
  const { activeBreakpoint } = useDevice()
  const isDesktop = activeBreakpoint === BreakpointSizes.L

  const modalVariant = isDesktop ? VARIANT_DEFAULT : VARIANT_FULLSCREEN
  const width = isDesktop ? 'auto' : '100%'
  const minWidth = isDesktop ? '400px' : 'inherit'
  const maxWidth = isDesktop ? 'min(var(--layout-max-width), 90%)' : '100%'

  return (
    <Modal
      title={intl.formatMessage({ id: 'global.room-details' })}
      handleClose={handleClose}
      show={isOpen}
      variant={modalVariant}
      width={width}
      minWidth={minWidth}
      maxWidth={maxWidth}
      displayHeaderShadow
    >
      <div className={styles.content}>{children}</div>
    </Modal>
  )
}

export default RoomDetailsModal
